<style lang="scss" scoped>
.day-configurator-planning {
    width: 100%;
    transition: opacity 0.2s, padding-left 0.3s;
    padding-left: 0;
    position: relative;

    @media screen and (min-width: 768px) {
        margin-left: auto;
        width: calc(100% - 400px);
    }

    @media screen and (max-width: 1279.98px) {
        overflow: scroll;
        -ms-overflow-style: none;
    }

    .no-schedule-message {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 5;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.3s;

        .popup {
            box-shadow: 0 0 32px 0 rgba(0, 0, 0, 0.3);

            p {
                max-width: 280px;
                text-align: center;
            }
        }
    }

    .expanded-title {
        display: none;

        .subtitle {
            color: #9e9e9e;
            font-size: 1rem;
        }
    }

    &.no-schedule {
        .no-schedule-message {
            opacity: 1;
        }

        .left-column,
        .right-column {
            pointer-events: none;
            filter: blur(10px);
        }
    }

    &.read-only {
        margin-left: 0 !important;
        width: 100% !important;
        overflow: scroll !important;

        .left-column {
            width: 100%;
            box-shadow: none;

            .title-container {
                box-shadow: none;
            }

            .time-planning-container {
                @media screen and (min-width: 768px) {
                    margin-left: auto;
                    margin-right: auto;
                    width: 600px;
                }
            }
        }

        ::v-deep .slot-inner {
            cursor: default !important;
        }

        ::v-deep .draggable,
        ::v-deep .resizable {
            pointer-events: none !important;

            .handle {
                display: none !important;
            }

            .tooltip-icon {
                pointer-events: all !important;
                cursor: default !important;
            }
        }
    }

    .simple-title {
        display: none;
    }

    .filter-title {
        font-size: 1rem !important;
        line-height: 2rem !important;
        margin-right: 8px !important;
        font-weight: 400 !important;
    }

    .filter-tags {
        .tag {
            transition: all 0.15s;
            border: 1px solid #fdeddc;
            cursor: pointer;

            &.active {
                background-color: #f39225;
                color: #fff;
                border-color: #f39225;
            }

            &:not(.active):hover {
                background-color: transparent;
                border: 1px solid #f39225;
                color: #f39225;
            }
        }
    }

    .expanded-title {
        display: block;
    }

    .floating-button {
        display: block;
    }

    .spinner-background {
        display: inline-block;
        opacity: 0;
        transition: opacity 0.5s;
        pointer-events: none;
        width: 72px;

        &.visible {
            opacity: 1;
        }

        .spinner {
            width: 16px;
            height: 16px;
            &:before {
                left: -28px;
                width: 16px;
                height: 16px;
            }
            &:after {
                left: 28px;
                width: 16px;
                height: 16px;
            }
        }
    }

    @media screen and (min-width: 1280px) {
        display: flex;
    }

    .left-column,
    .right-column {
        background-color: #fff;
        box-shadow: inset -1px 0 0 #e4e4e4;
        overflow: scroll;
        -ms-overflow-style: none;
        width: 100%;
        position: relative;

        @media screen and (max-width: 1279.98px) {
            overflow: visible;
        }

        @media screen and (min-width: 1280px) {
            width: 50%;
        }
    }

    .right-column {
        @media screen and (max-width: 1279.98px) {
            display: none;
        }

        p {
            font-size: 1.25rem;
            font-weight: 200;
            line-height: 1.875rem;
        }

        .ar {
            position: relative;
        }

        img {
            position: absolute;
            top: 0px;
            bottom: 0px;
            left: 0px;
            right: 0px;

            border-radius: 4px;
            width: 100%;
            height: 100%;
            object-fit: cover;
            font-family: "object-fit: cover;";
            -webkit-user-drag: none;
        }

        .title {
            font-size: 1rem;
            font-weight: 500;
            margin-bottom: 0;
            color: var(--dark);
            line-height: 1.25rem;

            &:hover {
                text-decoration: underline;
            }
        }

        .draggable {
            cursor: grab;
        }
    }

    .floating-button {
        position: fixed;
        z-index: 5;
        bottom: 32px;
        right: 50%;
        transform: translate(10px, 10px);
        display: none;

        @media screen and (max-width: 767.98px) {
            right: 32px;
            bottom: 76px;
        }

        @media screen and (min-width: 768px) and (max-width: 1279.98px) {
            right: 32px;
            bottom: 32px;
        }

        .tooltip {
            padding: 10px 16px;
            font-size: 1.25rem;
            font-weight: 300;
            line-height: 2.125rem;
            width: 200px;
        }

        .add-button {
            cursor: pointer;
            width: 56px;
            height: 56px;

            ::v-deep .icon {
                transition: box-shadow 0.3s, transform 0.3s;
                border-radius: 50%;
                position: relative;
                width: 56px;
                height: 56px;
                overflow: hidden;

                .icon-add-button {
                    position: absolute;
                    top: -5px;
                    left: -5px;
                }
            }

            &:hover {
                ::v-deep .icon {
                    box-shadow: 0 0 20px -5px rgba(0, 0, 0, 0.2);
                    transform: rotate(90deg);
                }

                .tooltip {
                    opacity: 1;
                    right: calc(100% + 16px);
                }
            }
        }
    }

    .request-offer {
        position: fixed;
        bottom: 0;
        z-index: 5;

        a {
            border-radius: 0;
        }
    }

    .title-container {
        box-shadow: inset 0 -1px 0 #e4e4e4;
    }

    .add-buttons a {
        border-radius: 4px;
        border: 1px solid #1f315a;
        padding: 12px 16px;
        color: #172340;
        font-size: 1rem;
        font-weight: 500;
        transition: border-color 0.2s;
        cursor: pointer;

        &:hover {
            border-color: var(--accent);
        }
    }

    .drag-message {
        border-radius: 4px;
        border: 1px solid var(--accent);
        background-color: var(--accent);
        height: 40px;
        font-size: 1rem;
        padding: 8px;
        color: #fff;
    }

    .add-gift {
        &:hover {
            color: var(--dark);
            background-color: #fff;
            border-color: var(--accent);
        }
    }

    .gift {
        width: 100%;
        height: 90px;
        border-radius: 4px;
        border: 1px solid #1f315a;
        padding: 0 24px;
        line-height: 1.1875;

        .thumbnail {
            width: 46px;
            height: 46px;
            border-radius: 50%;
            object-fit: cover;
            font-family: "object-fit: cover";
            margin-right: 16px;
        }

        a {
            display: inline-block;
            font-size: 0.875rem;
            font-weight: 300;
            text-decoration: underline;

            &.remove {
                color: #cccccc;
            }

            @media screen and (max-width: 767.98px) {
                font-size: 0.75rem;
            }
        }

        @media screen and (max-width: 767.98px) {
            padding: 0 16px;
        }
    }
}
</style>

<template>
    <div
        class="day-configurator-planning"
        :class="{
            'read-only': isReadOnly,
            'no-schedule': !hasSchedule && !isReadOnly
        }"
    >
        <!--<div class="no-schedule-message ">
            <div class="popup px-16 py-24 p-md-24">
                <p>Vul in de linkerkolom enkele praktische gegevens in om verder te gaan met je dagplanning.</p>
            </div>
        </div>-->
        <div class="left-column" ref="leftColumn">
            <div class="title-container px-16 py-24 px-md-40 py-md-32">
                <div class="simple-title">
                    <h2>{{ translations.day_planning.my_day }}</h2>
                </div>
                <div class="expanded-title" v-if="schedule.date_object != null">
                    <div
                        class="d-flex align-items-center mb-16"
                        :class="
                            canEdit
                                ? 'justify-content-between'
                                : 'justify-content-center'
                        "
                    >
                        <h2 class="d-inline-block mb-0">{{ formattedDate }}</h2>
                        <a
                            class="text-accent"
                            @click="$emit('previous-step')"
                            v-if="canEdit"
                            >{{ translations.day_planning.modify }}</a
                        >
                    </div>
                    <p class="subtitle" :class="{ 'text-center': isReadOnly }">
                        <template v-if="address">
                            {{ address
                            }}<span class="d-inline-block mx-16"
                                >&bull;</span
                            ></template
                        >{{ formattedAttendees }}
                    </p>
                </div>
            </div>

            <div
                class="time-planning-container px-16 pt-16 pb-80 px-md-40 pt-md-24 pb-md-96"
            >
                <div class="mb-32" v-if="canEdit">
                    <div class="d-flex flex-wrap add-buttons mb-n16">
                        <a
                            class="mr-12 mr-md-16 mb-12 mb-md-16 order-0"
                            @click.prevent="showAddPopup('activity')"
                            ><span class="d-inline-block mr-8">{{
                                translations.day_planning.activity.icon
                            }}</span
                            >{{ translations.day_planning.activity.label }}</a
                        >
                        <a
                            class="mr-12 mr-md-16 mb-12 mb-md-16 order-2 order-md-1"
                            @click.prevent="showAddPopup('catering')"
                            ><span class="d-inline-block mr-8">{{
                                translations.day_planning.catering.icon
                            }}</span
                            >{{ translations.day_planning.catering.label }}</a
                        >
                        <a
                            class="mr-12 mr-md-16 mb-12 mb-md-16 order-1 order-md-2"
                            @click.prevent="showAddPopup('break')"
                            ><span class="d-inline-block mr-8">{{
                                translations.day_planning.break.icon
                            }}</span
                            >{{ translations.day_planning.break.label }}</a
                        >
                        <a
                            class="mb-12 mb-md-16 order-3"
                            @click.prevent="showAddPopup('own_activity')"
                            ><span class="d-inline-block mr-8">{{
                                translations.day_planning.own_activity.icon
                            }}</span
                            >{{
                                translations.day_planning.own_activity.label
                            }}</a
                        >
                    </div>
                </div>

                <day-configurator-time-planning
                    class="mb-32"
                    :start="8"
                    :end="22"
                    :items="items"
                    :slots-per-hour="4"
                ></day-configurator-time-planning>

                <template
                    v-if="
                        canEdit ||
                            (schedule.gifts &&
                                schedule.gifts.length > 0 &&
                                getExternalItem(schedule.gifts[0]) != null)
                    "
                >
                    <h2 class="mb-16">
                        {{ translations.day_planning.gift.title
                        }}{{ schedule.gifts.length > 1 ? "s" : "" }}
                    </h2>
                    <template
                        v-if="schedule.gifts && schedule.gifts.length > 0"
                    >
                        <div
                            v-for="(gift, index) in schedule.gifts"
                            :key="index"
                            class="gift mb-16 d-flex align-items-center"
                        >
                            <div
                                class="d-flex"
                                v-if="
                                    getExternalItem(schedule.gifts[index]) !=
                                        null
                                "
                            >
                                <img
                                    class="thumbnail align-self-start align-self-md-center"
                                    :src="
                                        getExternalItem(schedule.gifts[index])
                                            .acf.image.sizes.medium_large
                                    "
                                    :alt="
                                        getExternalItem(schedule.gifts[index])
                                            .post_title
                                            ? getExternalItem(
                                                  schedule.gifts[index]
                                              ).post_title
                                            : getExternalItem(
                                                  schedule.gifts[index]
                                              ).title.rendered
                                    "
                                />
                                <div
                                    class="d-flex flex-column justify-content-center"
                                >
                                    <p
                                        v-html="
                                            getExternalItem(
                                                schedule.gifts[index]
                                            ).post_title
                                                ? getExternalItem(
                                                      schedule.gifts[index]
                                                  ).post_title
                                                : getExternalItem(
                                                      schedule.gifts[index]
                                                  ).title.rendered
                                        "
                                    ></p>
                                    <p class="actions mt-8" v-if="canEdit">
                                        <!--<a class="text-accent" @click.prevent="showAddGiftPopup">{{ translations.day_planning.gift.change }}</a>-->
                                        <a
                                            class="remove"
                                            @click.prevent="removeGift(index)"
                                            >{{
                                                translations.day_planning.gift
                                                    .remove
                                            }}</a
                                        >
                                    </p>
                                </div>
                            </div>
                        </div>
                    </template>
                    <a
                        v-if="canEdit"
                        class="add-gift btn btn btn-outline-dark"
                        @click.prevent="showAddGiftPopup"
                        ><span class="font-weight-bold d-inline-block mr-8"
                            >+</span
                        >{{ translations.day_planning.add_gift }}</a
                    >
                </template>
            </div>

            <div class="floating-button" v-if="canEdit">
                <div class="add-button" @click.prevent="showAddPopup('start')">
                    <span class="tooltip tooltip-left">{{
                        translations.day_planning.activity.label
                    }}</span>
                    <div
                        class="icon"
                        v-html="svg('add-button', 'icon-add-button')"
                    ></div>
                </div>
            </div>

            <div class="request-offer w-100 d-md-none" v-if="canEdit">
                <a
                    class="btn btn-accent w-100 text-white"
                    @click.prevent="requestOffer"
                    v-html="translations.header.request_offer"
                ></a>
            </div>
        </div>
        <div
            class="right-column p-24 px-md-40 py-md-32"
            ref="rightColumn"
            v-if="canEdit"
        >
            <h2 class="mb-8">{{ translations.day_planning.activities }}</h2>
            <p class="mb-24">
                Versleep een activiteit naar links in het tijdsschema om toe te
                voegen aan je dagplanning. Klik op de titel om meer te lezen
                over de activiteit.
            </p>
            <div class="tag-row filter-tags mb-40">
                <div class="tag-col">
                    <p class="filter-title">Filter:</p>
                </div>
                <div class="tag-col">
                    <div
                        @click="setFilter('activity')"
                        class="tag tag-accent-light tag-sm"
                        :class="{ active: filter === 'activity' }"
                    >
                        Activiteit
                    </div>
                </div>
                <div class="tag-col">
                    <div
                        @click="setFilter('speaker')"
                        class="tag tag-accent-light tag-sm"
                        :class="{ active: filter === 'speaker' }"
                    >
                        Spreker
                    </div>
                </div>
            </div>
            <!--<p
                class="mb-24"
                v-html="translations.day_planning.activities_description"
            ></p>-->
            <div class="row mb-16">
                <template
                    v-for="activity in items.activity.filter(
                        a =>
                            !a.acf.content.fixed_format ||
                            !a.acf.content.fixed_format.time_table
                    )"
                >
                    <div
                        v-if="filter === null || filter === 'activity'"
                        class="col-6 col-xl-4"
                        :key="activity.id"
                    >
                        <drag
                            :effect-allowed="'copy'"
                            :drop-effect="'copy'"
                            :transfer-data="{
                                action: 'drop-item',
                                type: 'activity',
                                data: activity
                            }"
                        >
                            <div class="draggable activity mb-32">
                                <div
                                    class="ar mb-8"
                                    :style="{
                                        'padding-top': `${(arHeight / arWidth) *
                                            100}%`
                                    }"
                                >
                                    <img
                                        :src="
                                            activity.acf.content.images[0].sizes
                                                .medium_large
                                        "
                                        :alt="activity.post_name"
                                    />
                                </div>
                                <a
                                    class="title"
                                    :href="
                                        route('nl.activity', activity.post_name)
                                    "
                                    target="_blank"
                                    v-html="
                                        activity.post_title
                                            ? activity.post_title
                                            : activity.title.rendered
                                    "
                                ></a>
                                <div class="tag-row mt-12">
                                    <div class="tag-col">
                                        <div
                                            class="tag tag-accent-light tag-xs"
                                        >
                                            Activiteit
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div slot="image">
                                <div class="drag-message">
                                    {{ translations.day_planning.drag_message }}
                                </div>
                            </div>
                        </drag>
                    </div>
                </template>
                <template v-for="speaker in items.speaker">
                    <div
                        v-if="filter === null || filter === 'speaker'"
                        class="col-6 col-xl-4"
                        :key="speaker.id"
                    >
                        <drag
                            :effect-allowed="'copy'"
                            :drop-effect="'copy'"
                            :transfer-data="{
                                action: 'drop-item',
                                type: 'speaker',
                                data: speaker
                            }"
                        >
                            <div class="draggable activity mb-32">
                                <div
                                    class="ar mb-8"
                                    :style="{
                                        'padding-top': `${(arHeight / arWidth) *
                                            100}%`
                                    }"
                                >
                                    <img
                                        :src="
                                            speaker.acf.image.sizes.medium_large
                                        "
                                        :alt="speaker.post_name"
                                    />
                                </div>
                                <a
                                    class="title"
                                    v-html="speaker.title.rendered"
                                    :href="
                                        route('nl.speaker', speaker.post_name)
                                    "
                                    target="_blank"
                                ></a>
                                <div class="tag-row mt-12">
                                    <div class="tag-col">
                                        <div
                                            class="tag tag-accent-light tag-xs"
                                        >
                                            Spreker
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div slot="image">
                                <div class="drag-message">
                                    {{ translations.day_planning.drag_message }}
                                </div>
                            </div>
                        </drag>
                    </div>
                </template>
            </div>

            <!--<h2 class="mb-8">{{ translations.day_planning.extras }}</h2>-->
            <!--<h2 class="mb-24">Sprekers</h2>-->
            <!--<p
                class="mb-24"
                v-html="translations.day_planning.extras_description"
            ></p>-->
            <!--<div class="row mb-n32">-->

            <!--
                <div
                    class="col-6 col-xl-4"
                    v-for="location in items.location"
                    :key="location.id"
                >
                    <drag
                        :effect-allowed="'copy'"
                        :drop-effect="'copy'"
                        :transfer-data="{
                            action: 'drop-item',
                            type: 'location',
                            data: location
                        }"
                    >
                        <div class="draggable activity mb-32">
                            <div
                                class="ar mb-8"
                                :style="{
                                    'padding-top': `${(arHeight / arWidth) *
                                        100}%`
                                }"
                            >
                                <img
                                    :src="location.acf.image.sizes.medium_large"
                                    :alt="location.post_name"
                                />
                            </div>
                            <p
                                class="title"
                                v-html="location.title.rendered"
                            ></p>
                            <div class="tag-row mt-12">
                                <div class="tag-col">
                                    <div class="tag tag-accent-light tag-xs">
                                        Locatie
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div slot="image">
                            <div class="drag-message">
                                {{ translations.day_planning.drag_message }}
                            </div>
                        </div>
                    </drag>
                </div>
                <div
                    class="col-6 col-xl-4"
                    v-for="staticItem in items.staticItem"
                    :key="staticItem.id"
                >
                    <drag
                        :effect-allowed="'copy'"
                        :drop-effect="'copy'"
                        :transfer-data="{
                            action: 'drop-item',
                            type: 'staticItem',
                            data: staticItem
                        }"
                    >
                        <div class="draggable activity mb-32">
                            <div
                                class="ar mb-8"
                                :style="{
                                    'padding-top': `${(arHeight / arWidth) *
                                        100}%`
                                }"
                            >
                                <img
                                    :src="
                                        staticItem.acf.image.sizes.medium_large
                                    "
                                    :alt="staticItem.post_name"
                                />
                            </div>
                            <p class="title" v-html="staticItem.post_title"></p>
                            <div class="tag-row mt-12">
                                <div class="tag-col">
                                    <div class="tag tag-accent-light tag-xs">
                                        Extra
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div slot="image">
                            <div class="drag-message">
                                {{ translations.day_planning.drag_message }}
                            </div>
                        </div>
                    </drag>
                </div>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>
import { Drag } from "vue-drag-drop";
import AddItemModal from "./modals/day-configurator-add-item-modal";
import AddGiftModal from "./modals/day-configurator-add-gift-modal";
import { bus } from "@/app";
import core from "./day-configurator-core";

export default {
    mixins: [core],

    components: { Drag },

    props: {
        items: {
            type: Object,
            required: true
        }
    },

    data: () => ({
        ratio: "284:200",
        address: "",
        filter: null
    }),

    mounted() {
        bus.$on("addressUpdate", address => {
            this.address = address;
        });

        this.$refs.leftColumn.addEventListener("scroll", function(e) {
            bus.$emit("column-scroll");
        });

        if (this.canEdit) {
            this.$refs.rightColumn.addEventListener("scroll", function(e) {
                bus.$emit("column-scroll");
            });
        }
    },

    methods: {
        showAddPopup(page = null) {
            bus.$emit("hideIntro");
            let props = {
                items: this.items
            };
            if (page != null) {
                props.openPage = page;
            }
            this.$modal.show(AddItemModal, props, {
                adaptive: true,
                pivotY: this.$root.isMobile ? 1 : 0.5,
                width: "616",
                height: "auto"
            });
        },

        showAddGiftPopup() {
            let props = {
                items: this.items
            };
            this.$modal.show(AddGiftModal, props, {
                adaptive: true,
                pivotY: this.$root.isMobile ? 1 : 0.5,
                width: "616",
                height: "auto"
            });
        },

        requestOffer() {
            bus.$emit("changeStep", "request-offer");
        },

        removeGift(index) {
            this.$store
                .dispatch("dayConfigurator/deleteGift", index)
                .then(() => {
                    this.$store.dispatch("dayConfigurator/update", {
                        schedule: this.schedule,
                        set: false
                    });
                });
        },

        setFilter(filter) {
            if (this.filter == filter) {
                this.filter = null;
            } else {
                this.filter = filter;
            }
        }
    },

    computed: {
        arWidth() {
            if (!this.ratio) return 0;
            return this.ratio.split(":")[0];
        },

        arHeight() {
            if (!this.ratio) return 0;
            return this.ratio.split(":")[1];
        },

        hasSchedule() {
            return this.schedule.id != null;
        }
    }
};
</script>
